import debounce from 'lodash.debounce';

const searchBox = instantsearch.connectors.connectSearchBox(
	(renderOptions, isFirstRender) => {
		if ( ! brookingsAlgoliaFeedOptions.facets.includes('search') ) {
			return;
		}
		const {
			query,
			refine,
			clear,
			isSearchStalled,
			widgetParams,
		} = renderOptions;

		const input = document.querySelector('#cs-search-field');
		const button = document.querySelector('#cs-search-submit');

		if (isFirstRender) {
			document.querySelector('#searchFacet').classList.add('active');

			const debouncedSearch = debounce(e => {
				refine(e.target.value);
				input.value = e.target.value;
			}, 100);

			input.addEventListener('input', event => {
				if (event.target.value.length > 3 || event.target.value.length == 0 ) {
					debouncedSearch(event);
				}
			});
		
			button.addEventListener('click', () => {
				clear();
			});
		}
	}
);

export default searchBox;